import { useQuery } from '@apollo/client';
import {
    GetWeeklyTripsAndEarningsTaxiDriverRequest,
    GetWeeklyTripsAndEarningsTaxiDriverResponse,
    CITRIN_GET_TRIPS_AND_EARNINGS_BY_TAXT_DRIVER,
} from '../index';
import { TaxiDriverEarningsFilter } from '../../shared/types';

export const useGetTripsAndEarningsTaxiDriverQuery = (request: TaxiDriverEarningsFilter) => {
    const { data, previousData, ...rest } = useQuery<
        GetWeeklyTripsAndEarningsTaxiDriverResponse,
        GetWeeklyTripsAndEarningsTaxiDriverRequest
    >(CITRIN_GET_TRIPS_AND_EARNINGS_BY_TAXT_DRIVER, {
        variables: { request },
        skip: !request.driverId || !request.startDate || !request.endDate,
        fetchPolicy: 'cache-and-network',
    });

    return {
        ...rest,
        previousData: previousData?.CITRIN_MGT_getWeeklyTripsAndEarningsByTaxiDriverId,
        data: data?.CITRIN_MGT_getWeeklyTripsAndEarningsByTaxiDriverId,
    };
};
